import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { Box, Button, Typography } from '@mui/material';
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { T } from 'react-translator-component';
import { colors } from '../../../../common/colors';
import GCBackButton from '../../../../components/GreenCity/GCBackButton';
import SubmitButton from '../../../../components/SubmitButton';
import Separator from '../../../../components/Separator';
import FindUserModal from '../../../../components/Models/GreenCity/FindUserModal';
import MessageModal from '../../../../components/Models/GreenCity/MessageModal';
import { ErrorMessageModal } from '../../../../components/ErrorMessageModal';
import LoadingModal from '../../../../components/LoadingModal';
import { styles } from '../../../styles';
import QRCode from "react-qr-code";
import profile from "../../../../assets/images/profile_img.png";
import appServices from '../../../../services/app-services/appServices';
import { convertUserImage } from '../../../../util/utils';

// eslint-disable-next-line
function InvitionLinkCreations(){
  const defaultImage = require("../../../../assets/images/default.png");

    const navigate = useNavigate();
    const groupInfo = useSelector((state: any) => state.gcGroup);
    const [open,setOpen]=useState<boolean>(false);
    const [loading,setLoading]=useState<boolean>(false);
    const [user,setUser]=useState<any>({})
    const [message,setMessage]=useState<string>('');
    const [openMessageModal, setOpenMessageModal]=useState<boolean>(false);
    const [openErrorMessageModal, setOpenErrorMessageModal]=useState<boolean>(false);
    const [isMember,setMemeber]=useState<boolean>(false);

    const link=`${process.env.REACT_APP_API_URL?.replace("api.",'')}/groupinvitation?link=${groupInfo?.id}`

    function copyTextFallback(text:string) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert(T("link_copied"));
    }

    function copyToClipboard() {
      try {
        navigator.clipboard.writeText(link).then(() => {
          alert(T("link_copied"));
        }).catch((err) => {
          console.error("Clipboard write failed, using fallback:", err);
          copyTextFallback(link);
        });
      } catch (err) {
        console.error("Clipboard API not supported, using fallback:", err);
        copyTextFallback(link);
      }
    }

    const addUser = async () => {
      setLoading(true);
      try {
        const body = {
          role: "member",
          member_group_id: groupInfo.id,
          user_id: user?.id,
          status: "invited"
        }
        await appServices.createMemberGroupUsers(body);
        setMessage(`${T('invitation_link_creations_invited')}`);
        setOpenMessageModal(true)
        setLoading(false);
        return true
      } catch (error: any) {
        setMessage(error?.response?.data?.message);
        setOpenErrorMessageModal(true)
        setLoading(false);
        return false
      }
    }

    const closeMessageModal = () => {
      setOpenMessageModal(false)
      setUser(undefined)
    }

    useEffect(()=>{
      if(!user?.id) return
      checkIsMemeber();
    },[user])

    const checkIsMemeber = async () => {
      if (groupInfo.id && groupInfo?.user?.id !== user?.id) {
        const res = await appServices.findMember(user?.id, groupInfo?.id);

        if (res?.member_group_user) {
          setMemeber(true);
        } else {
          setMemeber(false);
        }
      }
    };

  return (
    <div style={{ paddingTop: 100, margin: "0 10px" }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <LoadingModal visible={loading} handleClose={() => {}} />
      <Box style={{ padding: 16 }}>
        <Typography style={{ fontWeight: "700" }}>
          <img
            src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : defaultImage}
            alt={"user_img"}
            style={{
              ...styles.farmProfileIcon,
              height: 50,
              width: 50,
              margin: 0,
            }}
          />
          &nbsp;{groupInfo?.groupName}
        </Typography>
      </Box>

      <Separator sx={{ marginTop: "4px" , marginBottom: "4px" }} color={colors.farm_gray100} />

      <div
        style={{
          padding: "0 5px"
        }}
      >
        <Typography
          style={{
            borderBottomColor: colors.farm_green150,
            borderBottomWidth: 2,
            borderBottomStyle: "solid",
            fontSize: 14,
            margin: "16px 0px 6px",
            padding: "8px 10px",
          }}
        >
          <PeopleAltOutlinedIcon />
          &nbsp;{T("invitation_link_creations_invite_to_group")}
        </Typography>
        <div
          style={{
            padding: "0 10px"
          }}
        >
          <Typography style={{margin: "15px 0 10px"}}>{T("invitation_link_creations_invitation_qr")}</Typography>
          <Typography style={{fontSize: 14, color: '#747474', lineHeight: "23px"}}>
            {T("invitation_link_creations_invitation_qr_description")}
          </Typography>

          <div style={{ height: "auto", margin: "50px auto", maxWidth: 150, width: "100%" }}>
            <QRCode
              size={280}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={link}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
      </div>

      <Separator sx={{ marginTop: "4px" , marginBottom: "4px" }} color={colors.farm_gray100} />

      <Typography>{T("invitation_link_creations_send_invitation_link")}</Typography>
      <Typography style={{fontSize:12,color:'#747474'}}>{T("invitation_link_creations_invitation_link_description")}</Typography>
      <br/>
      <br/>
      <Typography style={{fontSize:12,color:'#747474'}}>{link}</Typography>
      <Button
        color="secondary"
        sx={style.submitButton}
        size={"large"}
        variant="outlined"
        onClick={copyToClipboard}
        endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faCopy} />}
      >
        {T("invitation_link_creations_copy_invitation_link")}
      </Button>

      <Typography>{T("invitation_link_creations_search")}</Typography>
      <Separator sx={{ marginTop: "4px" , marginBottom: "4px" }} color={colors.farm_gray100} />
      {user?.id&&<>
        <Typography style={{ fontWeight: "700" }}>
        <img
          src={user?.image !== null ? convertUserImage(user?.image) : profile}
          alt={"user_img"}
          style={{
            ...styles.farmProfileIcon,
            height: 50,
            width: 50,
            margin: 0,
          }}
        />
          &nbsp;{user?.nickname}
        </Typography>
        {isMember&& <Typography style={{fontSize:12,color:colors.farm_gray200}}>{T("invitation_link_creations_is_already_invited_or_member")}</Typography>}
        <SubmitButton
          color="secondary"
          sx={style.submitButton}
          size={"large"}
          variant="outlined"
          validate={async () => !isMember}
          onSubmit={addUser}
        >
          {T("invitation_link_creations_send_invitation")}
        </SubmitButton>
        <Separator sx={{ marginTop: "4px" , marginBottom: "4px" }} color={colors.farm_gray100} />
      </>}
      <Button
        color="secondary"
        sx={style.submitButton}
        size={"large"}
        variant="outlined"
        onClick={()=>setOpen(true)}
      >
        {T("invitation_link_creations_search_user")}
      </Button>

      <MessageModal
        open={openMessageModal}
        message={message}
        onClose={() => closeMessageModal()}
        onContinue={() => {}}
        showButton
        buttonText={T('close')}
        buttonStyles={style.messageModalButton}
      />
      <ErrorMessageModal
        open={openErrorMessageModal}
        messages={[message]}
        onClose={() => {setOpenErrorMessageModal(false)}}
      />
      <FindUserModal
        open={open}
        onClose={()=> setOpen(false)}
        onSelect={(user) => {
          setOpen(false);
          setUser(user);
        }}
      />
    </div>
  )
}

export default InvitionLinkCreations

const style = {
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom: 8,
  },
  messageModalButton: {
    color: colors.farm_blue200,
    border: "2px solid ",
    margin: "0px 30px",
    borderRadius: "10px",
    padding: "10px",
    width: "85%",
    maxWidth: 300,
  }
};